const createOrderFormSlice = (set) => ({

   personalnumberRef: "",
   nameRef: "",
   addressRef: "",
   postnumberRef: "",
   cityRef: "",
   emailRef: "",
   phoneRef: "",
   secondaddressRef: "",
   startDateInternetRef: "",
   startDateTvRef: "",
   messageRef: "",
   iAcceptPrivacy: false,
   iAcceptedTerms: false,

   setPersonalNumber: (value) => set({ personalnumberRef: value }),
   setName: (value) => set({ nameRef: value }),
   setAddress: (value) => set({ addressRef: value }),
   setPostnumber: (value) => set({ postnumberRef: value }),
   setCity: (value) => set({ cityRef: value }),
   setEmail: (value) => set({ emailRef: value }),
   setPhone: (value) => set({ phoneRef: value }),
   setSecondaddress: (value) => set({ secondaddressRef: value }),
   setStartDateInternet: (value) => set({ startDateInternetRef: value }),
   setStartDateTv: (value) => set({ startDateTvRef: value }),
   setMessage: (value) => set({ messageRef: value }),
   setIAcceptPrivacy: (value) => set({ iAcceptPrivacy: value }),
   setIAcceptedTerms: (value) => set({ iAcceptedTerms: value }),

   resetForm: () => set({
      personalnumberRef: "",
      nameRef: "",
      addressRef: "",
      postnumberRef: "",
      cityRef: "",
      emailRef: "",
      phoneRef: "",
      secondaddressRef: "",
      startDateInternetRef: "",
      startDateTvRef: "",
      messageRef: "",
      iAcceptPrivacy: false,
   }),

});

export default createOrderFormSlice;
